<template>
  <el-container class="friend-page">
    <el-aside  width="260px" class="friend-list-box">
      <el-menu
          default-active="/home/creation/explore" :router="true"
          class="el-menu-vertical-demo"
          @select="select"
        >
        <el-menu-item index="/home/creation/explore" >
          <template slot="title">
            <i class="el-icon-s-goods"></i>
            <span>探索</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/home/creation/document">
          <i class="el-icon-document"></i>
          <span slot="title">作品</span>
        </el-menu-item>
        <el-menu-item index="/home/creation/faka">
          <i class="el-icon-document"></i>
          <span slot="title">发卡</span>
        </el-menu-item>
        <el-menu-item index="/home/community/circle-list">
          <i class="el-icon-document"></i>
          <span slot="title">圈子</span>
        </el-menu-item>
        <el-menu-item index="/home/knowledgeBase/my">
          <i class="el-icon-document"></i>
          <span slot="title">知识库</span>
        </el-menu-item>
        <el-menu-item index="/home/creation/data">
          <i class="el-icon-s-data"></i>
          <span slot="title">资金</span>
        </el-menu-item>
        <el-menu-item index="/home/creation/paymentChannel">
          <span slot="title">支付通道配置</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>订单</span>
          </template>
        <el-menu-item style="text-align: right" index="/home/creation/order">
          <span slot="title">我售出的</span>
        </el-menu-item>
          <el-menu-item style="text-align: right"  index="/home/creation/buyorder">
            <span slot="title">我购买的</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container style="overflow: auto;text-align: left">
      <router-view></router-view>
    </el-container>
  </el-container>
</template>
<script>
import AddFriend from "@/components/friend/AddFriend.vue";
export default {
  name: "creation" ,
  components: { AddFriend},
  methods: {
    select(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  mounted(){
    window.$checkRealNameAuth();
    this.$router.push("/home/creation/explore");
  }
}
</script>
<style scoped lang="scss">
.friend-page {
  .friend-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);

    .friend-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;

      .add-btn {
        padding: 5px !important;
        margin: 5px;
        font-size: 16px;
        border-radius: 50%;
      }
    }

    .friend-list-items {
      flex: 1;
    }
  }

  .friend-box {
    display: flex;
    flex-direction: column;

    .friend-header {
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      font-size: var(--im-font-size-larger);
      border-bottom: var(--im-border);
      box-sizing: border-box;
    }

    .friend-detail {
      display: flex;
      padding: 50px 80px 20px 80px;
      text-align: center;


      .info-item {
        margin-left: 20px;
        background-color: #ffffff;
        border: 1px #ddd solid;
      }

      .description {
        padding: 20px 20px 0 20px;
      }
    }

    .frient-btn-group {
      text-align: left !important;
      padding: 20px;
    }
  }
}

</style>